"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetsSuccessForTenant = exports.assetsResetForTenant = exports.assetsGetPresignedRedirectForTenant = exports.assetsGetPresignedForTenant = exports.assetsErrorForTenant = exports.assetUploadSurveyResponseResetForTenant = exports.assetUploadSurveyResponseForTenant = void 0;
var _assetsForTenant = require("./assetsForTenant.constant");
// @flow

// common success
var assetsSuccessForTenant = function assetsSuccessForTenant(actionType, data) {
  return {
    type: _assetsForTenant.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.assetsSuccessForTenant = assetsSuccessForTenant;
var assetsErrorForTenant = function assetsErrorForTenant(actionType, error) {
  return {
    type: _assetsForTenant.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch presigned assets
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetsErrorForTenant = assetsErrorForTenant;
var assetsGetPresignedForTenant = function assetsGetPresignedForTenant(data) {
  return {
    type: _assetsForTenant.actionTypes.GET_ASSETS_PRESIGNED,
    payload: data
  };
};

/**
 * fetch presigned assets
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.assetsGetPresignedForTenant = assetsGetPresignedForTenant;
var assetsGetPresignedRedirectForTenant = function assetsGetPresignedRedirectForTenant(data) {
  return {
    type: _assetsForTenant.actionTypes.GET_ASSETS_PRESIGNED_REDIRECT,
    payload: data
  };
};

/**
 * upload
 * @param payload
 * @returns api response
 * @description this function used to upload.
 */
exports.assetsGetPresignedRedirectForTenant = assetsGetPresignedRedirectForTenant;
var assetUploadSurveyResponseForTenant = function assetUploadSurveyResponseForTenant(data) {
  return {
    type: _assetsForTenant.actionTypes.UPLOAD_SURVEY_RESPONSE,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.assetUploadSurveyResponseForTenant = assetUploadSurveyResponseForTenant;
var assetUploadSurveyResponseResetForTenant = function assetUploadSurveyResponseResetForTenant(data) {
  return {
    type: _assetsForTenant.actionTypes.UPLOAD_SURVEY_RESPONSE_RESET,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.assetUploadSurveyResponseResetForTenant = assetUploadSurveyResponseResetForTenant;
var assetsResetForTenant = function assetsResetForTenant(data) {
  return {
    type: _assetsForTenant.actionTypes.RESET,
    payload: data
  };
};
exports.assetsResetForTenant = assetsResetForTenant;